import React from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Gauge from 'components/shared/Gauge'
import ReadIcon from 'components/shared/ReadIcon'
import { toTitleCase, normaliseID, dateString } from 'utils/common'
import { ITank } from 'types'
import dateformat from 'dateformat'
import { TRACKERTYPES } from 'utils/constants'

interface IProps {
  tank: ITank
  locationTimeStamp?: any
  onClick: (tankId: string) => void
  source?: any
}
const Tank = ({ tank, locationTimeStamp, onClick, source }: IProps) => {
  if (TRACKERTYPES.includes(tank.type)) {
    return (
      <Grid
        container
        direction="column"
        className="clickable"
        style={{
          borderRadius: '5px',
          boxShadow: '0 3px 4px -2px #aaa',
          backgroundColor: '#fff',
          height: '100%',
        }}
      >
        <Grid item>
          <Box
            p={{ xs: 1 }}
            style={{
              backgroundColor: '#ebe3cd',
            }}
          >
            <Grid container justify="space-evenly">
              <Grid container direction="column" justify="flex-start" xs={12}>
                <Grid item>
                  <Typography variant="subtitle2" color="secondary">
                    {tank.name}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container direction="column" xs={5}>
                <Grid item>
                  <Typography variant="h6" color="secondary">
                    {tank.sh}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Box my={{ xs: 1 }} p={{ xs: 1 }}>
          <Grid container justify="space-evenly" onClick={() => onClick(tank.deviceID)}>
            <Grid container direction="column" justify="space-between" item xs={6}>
              <Grid item>
                <Typography variant="h6" color="secondary" align="right">
                  Type :
              </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary" align="right">
                  Device id :
              </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary" align="right">
                  Updated :
             </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary" align="right">
                  Product :
             </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary" align="right">
                  Size :
             </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary" align="right">
                  Cylinder # :
             </Typography>
              </Grid>
            </Grid>
            <Grid container direction="column" item xs={6}>
              <Grid item>
                <Typography variant="h6" color="secondary" >
                  {toTitleCase(tank.type)}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary" >
                  {normaliseID(tank.deviceID)}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary">
                  {(source != undefined && source == "mobile") ?
                    (tank.info.lastUpdatedDashBoard && dateString(tank.info.lastUpdatedDashBoard, true)) :
                    (tank.location !== undefined && (locationTimeStamp === undefined ? (dateformat(tank.location.datetime, "dd/mm/yyyy HH:MM")) : (dateformat(locationTimeStamp, "dd/mm/yyyy HH:MM"))))
                  }
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary">
                  {toTitleCase(tank.product)}
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="h6" color="secondary">
                  {toTitleCase(tank.size)}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6" color="secondary">
                  {toTitleCase(tank.equipment)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    )
  }
  else {
    return (
      <Grid
        container
        direction="column"
        className="clickable"
      >
        <Grid item>
          <Box
            p={{ xs: 1 }}
            style={{
              backgroundColor: '#ebe3cd',
            }}
          >
            <Grid container justify="space-between">
              <Grid item>
                <Typography variant="body2" color="secondary">
                  {tank.name}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="secondary">
                  {toTitleCase(tank.suburb)}
                </Typography>
              </Grid>
            </Grid>
            <Grid container justify="space-between">
              <Grid item>
                <Typography variant="h4" color="secondary">
                  {normaliseID(tank.deviceID)}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid container justify="space-evenly" onClick={() => onClick(tank.deviceID)}>
          <Grid container direction="column" justify="flex-start" item xs={3}>
            <Grid item>
              <Gauge tank={tank} />
            </Grid>
          </Grid>
          <Grid container direction="column" item xs={6}>
            <Grid item>
              <Box my={{ xs: 1 }}>
                <Typography variant="body2" color="secondary">
                  {toTitleCase(tank.street)}
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="secondary">
                {toTitleCase(tank.type)}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="secondary">
                {toTitleCase(tank.product)}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="secondary">
                {`${tank.capacity || 0} ${tank.info.uom}`}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="secondary">
                {(source != undefined && source == "mobile") ?
                  (tank.info.lastUpdatedDashBoard && dateString(tank.info.lastUpdatedDashBoard, true)) :
                  (tank.location !== undefined && (locationTimeStamp === undefined ? (dateformat(tank.location.datetime, "dd/mm/yyyy HH:MM")) : (dateformat(locationTimeStamp, "dd/mm/yyyy HH:MM"))))
                }
              </Typography>
            </Grid>
            {/* {tank.type !== 'pack' && (<Grid item>
              <Typography variant="body2" color="secondary">
              {locationTimeStamp === undefined ? (dateformat(tank.info.lastUpdated, "dd/mm/yyyy HH:MM")) : (dateformat(locationTimeStamp, "dd/mm/yyyy HH:MM"))}
              </Typography>
            </Grid>)} */}
            {/* <Grid item>
              <ReadIcon tank={tank} hideNormalStatus={true} />
            </Grid> */}
            {tank.edisetup && (
              <Grid item>
                <Typography variant="body2" color="secondary">
                  EDI Set up
                  </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    )
  }
}
export default Tank
